<template>
  <HomeLayout>
    <b-row class="column-border-container">
      <b-col class="column-border col-lg card-col col-12">
        <div @click="openCheckedBagModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">Checked Baggage</h4>
            <div class="nav-text-center">
              <i class="icon-checked_baggage vtd-icon-7"/>
            </div>
          </div>
          <CheckedBaggage :itineraryArr="itineraryArr"  ref="CheckedBaggageRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <div @click="openHandBagModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">Hand Baggage</h4>
            <div class="nav-text-center">
              <i class="icon-cabin_bag vtd-icon-7"/>
            </div>
          </div>
          <HandBaggage :itineraryArr="itineraryArr"  ref="HandBaggageRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>
    </b-row>
    <HomeBackBtns />
  </HomeLayout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HomeLayout from "@/partials/home-layout";
import CheckedBaggage from "@/modules/menu-bar/essential-info/baggage/checked";
import HandBaggage from "@/modules/menu-bar/essential-info/baggage/hand";

export default {
  components: {
    HomeLayout,
    CheckedBaggage,
    HandBaggage,
  },
  computed:{
    ...mapGetters({
      itinerary: 'booking/getItinerary',
    }),
    itineraryArr() {
      const flatItinArr = []
      this.itinerary.items.forEach((item) => {
        item.data.forEach((dataItem) => {
          if (dataItem.flightno) {
            flatItinArr.push(dataItem)
          }
        })
      })
      return flatItinArr
    },
  },
  data() {
    return {
      loginRes: {}
    }
  },
  async mounted() {
    if (this.$route.name === "baggageAuth") {
      this.loginRes = await this.loginOnStart({
        username: this.$route.params.surname,
        bookingNumber: this.$route.params.bookingNumber,
        source: this.$route.params.source,
      });
    }
    if (!this.loginRes) {
      this.$router.push("/login");
    }
    if (this.$route.query.pop === "checked") {
      this.openCheckedBagModal()
    }
    if (this.$route.query.pop === "hand") {
      this.openHandBagModal()
    }
    this.stopLoading() // not stopping
  },
  
  methods: {
    ...mapActions({
      loginOnStart: "auth/loginBookingNumberOnStartAction",
    }),
    openCheckedBagModal() {
      this.$refs.CheckedBaggageRef.showModal();
    },
    openHandBagModal() {
      this.$refs.HandBaggageRef.showModal();
    },
    stopLoading() {
      this.$emit("loading-bar", false);
    },
  },
};
</script>